import {
  put, call, all, takeLatest,
} from 'redux-saga/effects';
import { notification } from 'antd';
import { setTimesheet, setTimesheetFailure } from '../state/action/timesheetAction';
import { GET_TIMESHEET } from '../state/types';
import fetch from '../services/fetch';
import { BASE_URL } from '../config';

function* getTimesheet({
  startDate, endDate, projectNo, projectType
}) {
  let status = 0;
  try {
    const projNo = encodeURIComponent(projectNo).replace(/[!'()]/g, escape).replace(/\*/g, '%2A');
    const res = yield fetch(`${BASE_URL}/userTimesheet?startDate=${startDate}&endDate=${endDate}&projectNo=${projNo}&project_Type=${projectType}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    if (res.status === 403) {
      status = res.status;
      throw new Error('Unauthorized');
    }
    const response = yield res.json();
    yield put(setTimesheet({ response }));
  } catch (error) {
    yield put(setTimesheetFailure());
    if (status !== 403) {
      notification.error({
        message: 'There was a problem fetching the report details.',
        description: `${error}`,
      });
    }
  }
}

function* timesheetWatcher() {
  yield takeLatest(GET_TIMESHEET, getTimesheet);
}

function* timesheetSagas() {
  yield all([
    call(timesheetWatcher),
  ]);
}

export default timesheetSagas;
